angular.
module("dx.webapp.lti").
factory("dxLtiRoute", function ltiRouteService(
	$location,
	$window,

	DX_URLS
) {
	"use strict";

	return function ltiRoute(routeName, parameters) {
		var url = DX_URLS.get(routeName, parameters);
		var queryParams = $location.search();

		if ($window.Object.keys(queryParams).length === 0) {
			return url;
		}

		url += "?";

		for (var key in queryParams) {
			if (queryParams.hasOwnProperty(key)) {
				url += "&" + key + "=" + encodeURIComponent(queryParams[key]);
			}
		}

		return url;
	};
});
